define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/heading/SelectController"
], function(declare,lang,actionBase,SelectController) {

	return declare(SelectController, {
		process: function() {
			// summary: end this action and startup controller for selected action
			this.postProcess();
			
			var	a = this.heading.m_defActions.getAction(this.newValue);
			if (a) {
				setTimeout(lang.hitch(actionBase, "invoke", this.widget, this.m_element, a, null), 1);
			}
		}
	});
});